/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ref_N5Inputs */

const en_diff_ref_n5 = /** @type {(inputs: Diff_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Array elements are addressed by index in square brackets.`)
};

const ko_diff_ref_n5 = /** @type {(inputs: Diff_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열 요소는 대괄호 안의 인덱스로 지정됩니다.`)
};

const ja_diff_ref_n5 = /** @type {(inputs: Diff_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列要素は角かっこ内の添字で指定されます。`)
};

/**
* | output |
* | --- |
* | "Array elements are addressed by index in square brackets." |
*
* @param {Diff_Ref_N5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ref_n5 = /** @type {((inputs?: Diff_Ref_N5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ref_N5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ref_n5(inputs)
	if (locale === "ko") return ko_diff_ref_n5(inputs)
	return ja_diff_ref_n5(inputs)
});